export const siteConfig = {
  name: "Armerta ERP",
} as const;
